import { FC, SVGProps } from "react";

export const CheckIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="10"
    viewBox="0 0 14 10"
    className="fill-white"
    {...props}
  >
    <path d="M4.78653 9.70261L0.766113 5.65615L1.6976 4.72469L4.78653 7.78758L12.3025 0.297607L13.234 1.25511L4.78653 9.70261Z" />
  </svg>
);
